import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

const headStyles = css`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.secondary.labels};
  margin-bottom: 5px;

  &:hover {
    color: ${({ theme }) => theme.palette.secondary.labels};
  }
`;

const lastItemStyles = css`
  margin-bottom: 0;
`;

const contactUsStyles = css`
  margin-top: 30px;
`;

const leftIconStyles = ($leftIcon: {
  name: string;
  width?: number;
  height?: number;
}) => css`
  position: relative;
  &::before {
    content: '';
    mask-image: url('/images/${$leftIcon.name}');
    width: ${$leftIcon.width ?? 20}px;
    height: ${$leftIcon.height ?? 20}px;
    mask-position: center;
    mask-size: contain;
    mask-repeat: no-repeat;
    background-color: ${({ theme }) => theme.palette.primary.labels};
  }
`;

export const BusinessNavigation = styled.div<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 266px;
  position: absolute;
  top: 60px;
  background-color: #fff;
  transition: 0.3s ease-in-out;
  z-index: 99999;
  padding: 0 15px;
`;

export const BusinessNavClose = styled(Button)`
  margin-left: auto;
`;
export const BusinessNavContainer = styled.div`
  width: calc(100% - 60px);
  max-width: 1280px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 0 auto;
`;

export const BusinessNavColumn = styled.div<{
  $isLeftContent?: boolean;
}>`
  display: flex;
  flex-direction: column;
  ${({ $isLeftContent }) =>
    $isLeftContent &&
    css`
      align-items: flex-end;
    `}
`;

export const BusinessNavItem = styled(Typography.Body)<{
  $isHead?: boolean;
  $isLast?: boolean;
  $isContactUsItem?: boolean;
  $leftIcon?: { name: string; width?: number; height?: number };
}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  gap: 15px;
  color: ${({ theme }) => theme.palette.primary.labels};
  position: relative;
  font-size: 16px;
  transition: 0.1s linear;

  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};
    &::before {
      background-color: ${({ theme }) => theme.palette.brand.main};
    }
  }

  & > button h6 {
    font-size: 16px;
    &:hover {
      color: ${({ theme }) => theme.palette.brand.main};
    }
  }

  ${({ $isHead }) => $isHead && headStyles}
  ${({ $isLast }) => $isLast && lastItemStyles}
  ${({ $isContactUsItem }) => $isContactUsItem && contactUsStyles}
  ${({ $leftIcon }) => $leftIcon && leftIconStyles($leftIcon)}
`;

export const BusinessNavSocials = styled.div`
  width: 100%;
  display: flex;
  gap: 25px;
  justify-content: flex-end;
`;
